interface MaskGroup {
  separator?: string;
  startIndex: number;
  endIndex: number;
}

export function customMask(value: string, pattern: string): string {
  const groups: MaskGroup[] = [];
  let currentGroup: MaskGroup | null = null;
  let startIndex = 0;
  let endIndex = 0;

  for (const char of pattern) {
    if (/\d/.test(char)) {
      if (!currentGroup) {
        currentGroup = { startIndex, endIndex };
      } else {
        currentGroup.endIndex++;
        startIndex++;
        endIndex++;
      }
    } else {
      if (currentGroup) {
        groups.push({ ...currentGroup });
        currentGroup = null;
      }

      if (char !== '9') {
        startIndex++;
        endIndex++;
        groups.push({
          separator: char,
          startIndex,
          endIndex,
        });
        startIndex++;
        endIndex++;
      }
    }
  }

  if (currentGroup) {
    groups.push({ ...currentGroup });
  }

  let result = '';

  for (const group of groups) {
    const groupValue = value.substring(group.startIndex, group.endIndex + 1);

    if (groupValue) {
      if (
        group.separator &&
        result.length === group.startIndex &&
        result.length === group.endIndex
      ) {
        result += group.separator;
      }

      result += groupValue.replace(/\D/g, '');
    }
  }

  return result;
}
